"use client";

import { useParams } from "next/navigation";
import { Suspense } from "react";
import { NewsViewPage } from "../../skin/news";
import { MediaViewPage } from "../../skin/media";
import { SsgoiTransition } from "@ssgoi/react";
import { Loading } from "@/shared";

export function ArticleViewPage() {
  const params = useParams<{ slug: string }>();
  const slug = params?.slug;

  return (
    <Suspense>
      <SsgoiTransition id="/app/articles/[id]">
        {slug === "news" && <NewsViewPage />}
        {slug === "media" && <MediaViewPage />}
        {slug !== "news" && slug !== "media" && <Loading />}
      </SsgoiTransition>
    </Suspense>
  );
}
